<template>
  <div class="ui-segmented">
    <div
      v-for="label of innerLabels"
      :key="label.value"
      class="ui-segmented__tab"
      :class="getLabelClass(label)"
      @click="$emit('update:modelValue', label.value);"
    >
      <div class="ui-segmented__label">
        <f-sprite-icon
          v-if="label.icon"
          :icon-link="label.icon"
          class="ui-segmented__icon"
        />
        {{ label.label }}
      </div>
      <div v-if="label.content" class="ui-segmented__content">
        {{ label.content }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ui-segmented',

  props: {
    labels: {
      type: Array,
      required: true,
    },

    modelValue: {
      type: String,
      required: true,
    },
  },

  computed: {
    innerLabels() {
      return this.labels.map((label) => (
        typeof label === 'object' ? label : { value: label, label }
      ));
    },
  },

  methods: {
    getLabelClass(label) {
      return {
        'ui-segmented__tab_active': this.modelValue === label.value,
        'ui-segmented__tab_icon': !!label.icon,
        'ui-segmented__tab_icon-only': !label.label,
      };
    },
  },
};
</script>

<style lang="scss">
.ui-segmented {
  display: flex;
  border: 1px solid $gray_lu;
  border-radius: 4px;
  color: $gray;
  text-align: center;

  &__tab {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    flex: 1 1 50%;
    padding: 10px 20px;
    cursor: pointer;

    &::before,
    &::after {
      content: '';
      position: absolute;
    }

    &::before {
      @include stacking("infront");
      top: -1px;
      right: -1px;
      bottom: -1px;
      left: -1px;
      border: 2px solid $black;
      opacity: 0;
      transition: .2s opacity ease, .2s color ease;
    }

    &:not(:last-child)::after {
      top: 0;
      right: 0;
      width: 1px;
      height: 100%;
      background-color: $gray_lu;
    }

    &:first-child::before {
      border-radius: 4px 0 0 4px;
    }

    &:last-child::before {
      border-radius: 0 4px 4px 0;
    }

    &_active {
      color: $black;
      pointer-events: none;

      &::before {
        opacity: 1;
      }
    }

    &_icon {
      padding: 10px 14px;
    }

    &_icon-only {
      padding: 4px 9px;
      width: 49px;

      .ui-segmented__icon {
        width: 32px;
        min-height: 32px;
        margin-right: 0;
      }
    }
  }

  &__icon {
    flex-shrink: 0;
    width: 20px;
    height: 20px;
    margin-right: 4px;
  }

  &__label {
    display: flex;
    line-height: 20px;
    font-size: 14px;
    font-weight: 600;
  }

  &__content {
    font-size: 12px;
    line-height: 16px;
    font-weight: 400;
  }
}

@include breakpoint("desktop") {
  .ui-segmented {
    &__tab {
      width: auto;
      transition: .2s ease color, .2s ease background-color;
      cursor: pointer;

      &:hover {
        @include stacking("base");
        background-color: $gray_bgr;
        color: $black;
      }
    }
  }
}
</style>
